import React from 'react'

import Info from 'assets/svg/info.svg'

import ProductCard from '../ProductCard'

import { cards } from '../../../constants/cards'
import { BANCODOBRASIL, BRADESCO } from '../../../constants/banks'

const DefaultProductCard = (props) => {
    const card = cards.find((c) => c.id === props.id)

    const getMessage = () => {
        switch (props.base) {
            case BRADESCO:
                return 'Para contratar o produto, entre em contato com a nossa central de vendas e informe o número da sua agência de relacionamento. Telefone da Central de Vendas Bradesco: 4003-3225'
            case BANCODOBRASIL:
                return 'Para contratar o produto, entre em contato com a nossa central de vendas e informe o número da sua agência de relacionamento. Telefone da Central de Vendas Banco do Brasil: 4003-3665'
            default:
                return 'Para verificar o processo de contratação, acesse o link abaixo:'
        }
    }

    return (
        <ProductCard
            {...props}
            id={card.type}
            background={card.bgImage}
            card={card.image}
            name={card.name}
            customName={card.customName}
            link={card.link}
            description={card.description}
        >
            {(backFlip, id) => (
                <div className="product-card--back--content">
                    <div className="info">
                        <img src={Info} alt="info" />
                        <p className={props.base && 'bank-message'}>
                            {props.code === '202'
                                ? 'Este é um produto sazonal, ainda não estamos comercializando diretamente aqui em nossa Loja.'
                                : 'Este produto ainda não é comercializado diretamente aqui em nossa Loja.'}
                            <br />
                            <br />
                            {getMessage()}
                        </p>
                    </div>
                    <div className="product-card--actions">
                        {!props.base && (
                            <a
                                href={card.link}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <b>Acessar mais informações</b>
                            </a>
                        )}
                        <button
                            id={`backFlip${id}`}
                            type="button"
                            onClick={() => {
                                backFlip()
                            }}
                            className="product-card__button product-card__button--close"
                        >
                            Fechar
                        </button>
                    </div>
                </div>
            )}
        </ProductCard>
    )
}

export default DefaultProductCard
